export class RestoreMicrosoft365Request {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "WorkspaceRestoreMode",
            "format": ""
        },
        {
            "name": "restoreTargetUpn",
            "baseName": "restoreTargetUpn",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreTargetFolder",
            "baseName": "restoreTargetFolder",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365Request.attributeTypeMap;
    }
    constructor() {
    }
}
